import React from 'react';

const Window = ({
  className = "",
  contentClassName = "",
  children,
  bottomLeft = null,
  bottomRight = null,
}) => (
  <div className={`w-full h-full p-2 bg-[#FCFCFC] dark:bg-[#1A1A1A] border border-[#ECECEC] dark:border-[#202020] rounded-3xl flex flex-col min-h-0 ${className}`}>
    <div className={`h-full w-full bg-[#FFFFFF] dark:bg-[#121212] border border-[#ECECEC] dark:border-[#202020] rounded-2xl overflow-hidden flex-1 min-h-0 ${contentClassName}`}>
      {children}
    </div>

    <div className="p-2 pt-4 flex items-center justify-between">
      <div className="flex items-center space-x-2">{bottomLeft}</div>
      <div className="flex items-center space-x-2">{bottomRight}</div>
    </div>
  </div>
);

export default Window;